import React, { useRef } from 'react';
import styled from "styled-components";
import { TextControl } from "../generic/Core";

const InputField = ({
  name,
  inputId,
  value,
  placeholder,
  isReadOnly,
  handleArrowClick,
  onInputChange,
  onInputBlur,
  onFocus,
  isRed,
  inputMode,
  inputRef,
  testId
}) => {
  // Function to handle key press
  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" && !e.ctrlKey) {
      e.preventDefault();
      handleArrowClick(1);
    } else if (e.key === "ArrowDown" && !e.ctrlKey) {
      e.preventDefault();
      handleArrowClick(-1);
    }
  };

  const handleFocus = (e) => {
    onFocus()
    inputRef.current.select();
  };


  return (
    <TextControl
      type="text"
      id={inputId || name}
      name={name}
      inputMode={inputMode}
      autoComplete="off"
      value={value}
      placeholder={placeholder}
      onChange={onInputChange}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      onBlur={onInputBlur}
      ref={inputRef}
      {...(isRed && { required: true })}
      data-testid={testId}
    />
  );
};

export default InputField;
